import { css } from "../../../styled-system/css";

export const styles = {
  whiteBackground: () =>
    css({
      position: "relative",
      width: "100vw",
      left: "50%",
      marginLeft: "-50vw",
      backgroundColor: "white",
    }),
  textWrapper: () =>
    css({
      paddingY: "baseUnit.mobile2",
      color: "headlineGrey",
      "& p": {
        fontSize: "body.mouse",
        lineHeight: "body.mouse",
        letterSpacing: "body.mouse",
        marginBottom: 0,
      },
      "& b": {
        fontWeight: "bold",
      },
    }),
};
